import { create } from 'zustand';

const useLocationsIntegrationsHoursStore = create((set, get) => ({
  // Current display tab
  display: 'Locations',
  
  // Actions
  setDisplay: (newDisplay) => set({ display: newDisplay }),
  
  // Reset to default
  resetDisplay: () => set({ display: 'Locations' }),
}));

export default useLocationsIntegrationsHoursStore;